import React from "react";
import "./Hero.css";

import heroSm from "../../assets/images/IMG_4463-sm.jpg";
import heroMd from "../../assets/images/IMG_4463-md.jpg";
import heroLg from "../../assets/images/IMG_4463-lg.jpg";

import { useLanguage } from "../../context/LanguageContext";

const Hero = () => {
  const { t } = useLanguage();

  return (
    <section className="hero">

      <img
        className="hero-bg"
        src={heroSm}
        srcSet={`${heroSm} 600w, ${heroMd} 1200w, ${heroLg} 2000w`}
        sizes="100vw"
        alt={t.hero.alt}
        loading="eager"
        fetchPriority="high"
      />

      <div className="hero-overlay"></div>

      <div className="hero-content">
        <h1>
          {t.hero.title} <br />
          <span>{t.hero.titleHighlight}</span>
        </h1>

        <p>{t.hero.description}</p>

        <div className="hero-buttons">
          <a href="#contact" className="btn-hero-primary">
            {t.hero.primaryButton}
          </a>
          <a href="#gallery" className="btn-hero-secondary">
            {t.hero.secondaryButton}
          </a>
        </div>
      </div>

    </section>
  );
};

export default Hero;
